// The sanctioned avatar badge palette, mirrored from `listful-api/docs/BRAND.md`
// and kept in the SAME ORDER as iOS (`listful-ios/.../Config/Theme.swift`
// `BrandPalette.swatches`) so the deterministic default color for a given user
// id is identical on web and iOS.

export const AVATAR_PALETTE = [
    { name: 'Sky', hex: '#0284C7' },
    { name: 'Violet', hex: '#7C3AED' },
    { name: 'Fuchsia', hex: '#C026D3' },
    { name: 'Rose', hex: '#E11D48' },
    { name: 'Coral', hex: '#F97316' },
    { name: 'Amber', hex: '#F59E0B' },
    { name: 'Emerald', hex: '#059669' },
    { name: 'Teal', hex: '#0D9488' },
    { name: 'Slate', hex: '#334155' },
    { name: 'Indigo', hex: '#4F46E5' },
];

// Deterministic default badge color for a user who hasn't picked one. Must match
// iOS `BrandPalette.color(forSeed:)`: `swatches[((seed % count) + count) % count]`.
export function defaultAvatarColor(id) {
    const count = AVATAR_PALETTE.length;
    const seed = Number.isFinite(id) ? id : 0;
    return AVATAR_PALETTE[(((seed % count) + count) % count)].hex;
}

// Turn a "#RRGGBB" hex into an `rgba()` string at the given alpha — used for the
// 20%-opacity badge fill (initials text uses the full-strength hex), matching the
// iOS badge (`color.opacity(0.2)` fill, `color` text).
export function hexToRgba(hex, alpha) {
    const clean = String(hex).replace('#', '');
    const r = parseInt(clean.slice(0, 2), 16);
    const g = parseInt(clean.slice(2, 4), 16);
    const b = parseInt(clean.slice(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
